import { AccordionTypeTokens, ColorTokens, IconTokens, } from '@voltmoney/schema';
import React from 'react';
import Typography from '../typography/Typography';
export const args = {
    title: 'Approved Cash List',
    activeIndex: 1,
    description: 'We would love to hear from you. You can get back to us via Call, Email or WhatsApp.',
    icon: IconTokens.DownArrow,
    data: [
        {
            id: 1,
            header: {
                children: (React.createElement(Typography, { label: 'Check portfolio credit limit data', color: ColorTokens.Grey_300 })),
            },
            body: {
                children: (React.createElement(Typography, { label: 'Check portfolio credit limit data body', color: ColorTokens.Grey_300 })),
            },
        },
        {
            id: 2,
            header: {
                children: (React.createElement(Typography, { label: 'Set credit limit ', color: ColorTokens.Grey_300 })),
            },
            body: {
                children: (React.createElement(Typography, { label: 'Set credit limit data', color: ColorTokens.Grey_300 })),
            },
        },
        {
            id: 3,
            header: {
                children: (React.createElement(Typography, { label: 'Set credit limit data', color: ColorTokens.Grey_300 })),
            },
            body: {
                children: (React.createElement(Typography, { label: 'Interest and other charges data', color: ColorTokens.Grey_300 })),
            },
        },
        {
            id: 4,
            header: {
                children: (React.createElement(Typography, { label: 'Set credit limit data', color: ColorTokens.Grey_300 })),
            },
            body: {
                children: (React.createElement(Typography, { label: 'How it works? data', color: ColorTokens.Grey_300 })),
            },
        },
    ],
    onPress: Function,
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(AccordionTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    onPress: { action: 'clicked' },
};
